import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { newsActions } from '../actions/news.actions';
import { selectNews, selectNewsLoaded, selectNewsLoading } from '../selectors/news.selectors';
import { filter } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class NewsFacade {
    private readonly store = inject(Store);

    readonly news$ = this.store.select(selectNews);
    readonly newsNonNullable$ = this.store.select(selectNews).pipe(filter((data) => data !== null));
    readonly newsLoading$ = this.store.select(selectNewsLoading);
    readonly newsLoaded$ = this.store.select(selectNewsLoaded);

    getNews() {
        this.store.dispatch(newsActions.getNews());
    }

    clear() {
        this.store.dispatch(newsActions.clear());
    }
}
